module.exports = "/packs/thankyou-2c5463c3758b6dc3974bb9470d7f257e.png";